import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ThemeToggle from "@/components/ThemeToggle";
import Logo from "@/components/Logo";

const links = [
  { id: "home", label: "Home" },
  { id: "services", label: "Services" },
  { id: "process", label: "Process" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export default function Nav() {
  const [active, setActive] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const onLanding = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 24);
      if (!onLanding) return;
      const offsets = links.map((l) => {
        const el = document.getElementById(l.id);
        if (!el) return { id: l.id, top: Infinity };
        const r = el.getBoundingClientRect();
        return { id: l.id, top: Math.abs(r.top - 120) };
      });
      offsets.sort((a, b) => a.top - b.top);
      setActive(offsets[0].id);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [onLanding]);

  const go = (id) => {
    if (!onLanding) {
      window.location.href = `/#${id}`;
      return;
    }
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
      window.__lenis.scrollTo(el, { offset: -60 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled ? "py-3" : "py-6"
      }`}
    >
      <div
        className={`mx-auto max-w-7xl px-5 sm:px-8 flex items-center justify-between ${
          scrolled
            ? "bg-[var(--bg)]/60 backdrop-blur-xl border border-[var(--border-dim)] rounded-full"
            : ""
        } transition-all duration-500`}
        style={scrolled ? { padding: "10px 18px" } : {}}
      >
        <Link
          to="/"
          data-testid="nav-brand"
          className="flex items-center gap-2 group"
        >
          <Logo variant="full" />
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="relative px-4 py-2 font-mono-ui text-[11px] tracking-[0.22em] uppercase text-[var(--text-3)] hover:text-[var(--text-1)] transition-colors"
            >
              {onLanding && active === l.id && (
                <span className="absolute inset-0 rounded-full border border-[var(--border-dim)] bg-[var(--surface)]/40" />
              )}
              <span className="relative">{l.label}</span>
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <ThemeToggle />
          <button
            data-testid="nav-cta-book"
            onClick={() => go("contact")}
            className="group relative inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[var(--vermilion)] text-white text-xs font-medium tracking-wide hover:bg-[var(--vermilion-2)] transition-colors"
          >
            <span>Contact us</span>
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-[var(--lime)]" />
          </button>
        </div>
      </div>
    </header>
  );
}
